import { IRefIds } from 'constants/refs';
import { del, get, post, put } from 'services/request';
import { BaseModel, IModelOptions } from './BaseModel';
import { IItemSourceGuesserCreate, IItemSourceGuesserEdit, IItemSourceGuesserListItem } from 'types/itemSourceGuesser';
import { IKline } from '../types/klines';

export type ItemSourceGuesserModelOptions = IModelOptions & {
  courseId: number;
};

export class ItemSourceGuesserModel extends BaseModel<
  IItemSourceGuesserListItem,
  IItemSourceGuesserEdit
> {
  constructor(options: ItemSourceGuesserModelOptions) {
    super(options);
    this.ref = IRefIds.itemSourceGuesser;
    this.gridName = 'ItemSourceGuesser';
    this.courseId = options.courseId;
    this.getGridColumns();
  }

  async getGrid() {
    await super.getGrid();
    this.gridData = await get<IItemSourceGuesserListItem[]>(`/courses/${this.courseId}/item-source-guesser`);
    this.loadingGrid = false;
    this.render();
  }

  async getGridRow(itemId: number) {
    return await get<IKline>(`/courses/${this.courseId}/item-source-guesser/${itemId}`);
  }

  async createJob(data: IItemSourceGuesserCreate) {
    const response = await post<{ id: number; message: string }>(`/courses/${this.courseId}/item-source-guesser`, data);
    await this.getGrid();
    return response;
  }

  async delete() {
    await del(`item-source-guesser/${this.itemId}`);
    this.itemId = -1;
    await this.getGrid();
  }

  async reload() {
    await super.reload();
    await this.getGrid();
  }

  async loadItemData(itemId: number) {
    return await get<IItemSourceGuesserEdit>(`item-source-guesser/${itemId}`);
  }

  async changePriority(itemId: number, priority: number) {
    await put(`/item-source-guesser/${itemId}/change-priority`, { priority });
  }
}
